<interview-wrapper [title]="'interviews.Thanks for your feedback' | translate">
    <div step-content>
        <p class="body text-center">{{'interviews.Feedback Submitted' | translate}}</p>
    </div>
</interview-wrapper>